import React, { useState, useEffect } from "react";
import { API, graphqlOperation } from "aws-amplify";
import {
  listCreateOrderOfBillings,
  getCreateOrderOfBilling,
} from "../../graphql/queries";
import { updateCreateOrderOfBilling } from "../../graphql/mutations";
import fetchItemsNextToken from "../../function/fetchItemsNextTokenZau";
import {
  Card,
  Modal,
  Button,
  Alert,
  Row,
  Col,
  Input,
  notification,
  Statistic,
  Tag,
  Descriptions,
  Collapse,
  Table,
  Image,
} from "antd";
import { UserOutlined } from "@ant-design/icons";
import Swal from "sweetalert2";
import "sweetalert2/src/sweetalert2.scss";
import Zaupayitem from "../../json/payitemZau.json"

import GenerateOp from "../../http/generateOP-be"




const { Panel } = Collapse;

const user = JSON.parse(localStorage.getItem("profile"));

const Approver5 = (props) => {
  const [dataAll, setDataAll] = useState([]);
  const [listoforderpayment, setlistoforderpayment] = useState([]);
  const [listoforderpaymentNot, setlistoforderpaymentNot] = useState([]);
  const [listofpaid, setlistoforderpaid] = useState([]);
  const [listofForPaymentApproved, setlistofForPaymentApproved] = useState([]);
  const [numberOfPaid, setNumberOfPaid] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [checkArray, setCheckedArray] = useState([]);
  const [opData, setOpData] = useState([]);
  const [signature, setSignature] = useState("");
  const [orderpaymentid, setOrderpaymentid] = useState(null);
  const [approved, setApproved] = useState("0");
  const [toSearch, setToSearch] = useState("");
  const [forFilterSearch, setForFilterSearch] = useState([]);
  const [data, setData] = useState([]);
  const [dataList, setDataList] = useState(listoforderpaymentNot);
  const [showmodalRemarks, setShowmodalRemarks] = useState(false);
  const [remarksArray, setRemarksArray] = useState([]);
  const [title, setTitle] = useState("List of Approval");
  const [attachmentId, setAttachmentId] = useState([]);
  const [disabledApproved, setdisabledApproved] = useState(false);

  useEffect(() => {
    fetchListofOrderofPaymentsNot();
    const intervalId = setInterval(() => {
      fetchListofOrderofPaymentsNot();
    }, 5000); // Refresh data every 5 seconds

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  useEffect(() => {
    fetchListofOrderofPayments();
    const intervalId = setInterval(() => {
      fetchListofOrderofPayments();
    }, 5000); // Refresh data every 5 seconds

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  useEffect(() => {
    fetchListofPaid();
    const intervalId = setInterval(() => {
      fetchListofPaid();
    }, 5000); // Refresh data every 5 seconds

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  useEffect(() => {
    fetchOrderOfpaymentForPayment();
    const intervalId = setInterval(() => {
      fetchOrderOfpaymentForPayment();
    }, 5000); // Refresh data every 5 seconds

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  const fetchOrderOfpaymentForPayment = async () => {
    const queryData = {
      query: listCreateOrderOfBillings,
      variables: {
        filter: {
          isDeleted: { notContains: "1" },
        },
        limit: 1000,
      },
    };

    const a = fetchItemsNextToken(queryData);
    a.then(async (response) => {
      const f = response.filter(
        (item) =>
          item.order_payment_no === "0" &&
          item.Signature1 === "1" &&
          item.Signature2 === "1"
      );

      setlistofForPaymentApproved(
        f.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
      );
    });
  };

  const fetchListofPaid = async () => {
    const queryData = {
      query: listCreateOrderOfBillings,
      variables: {
        filter: {
          opStatus: { eq: "1" },
          Signature1: { eq: "1" },
          Signature2: { eq: "1" },
          isDeleted: { ne: "1" },
          OrNumber: { ne: "0" },
        },
        limit: 1000,
      },
    };

    const a = fetchItemsNextToken(queryData);
    a.then(async (response) => {
      setNumberOfPaid(
        response.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
      );
    });
  };

  const fetchListofOrderofPayments = async () => {
    const queryData = {
      query: listCreateOrderOfBillings,
      variables: {
        filter: {
          status:{eq:"4"},
          isDeleted: { ne: "1" },
        },
        limit: 1000,
      },
    };

    const a = fetchItemsNextToken(queryData);
    a.then(async (response) => {
      setlistoforderpayment(
        response.sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt))
      );
    });
  };

  const fetchListofOrderofPaymentsNot = async () => {
    const queryData = {
      query: listCreateOrderOfBillings,
      variables: {
        filter: {
          status:{eq:"3"},
          isDeleted: { ne: "1" },
        },
        limit: 1000,
      },
    };

    const a = fetchItemsNextToken(queryData);
    a.then(async (response) => {
      setlistoforderpaymentNot(
        response.sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt))
      );
      setForFilterSearch(
        response.sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt))
      );
    });
  };

  const handleLoadApprovedWithBillingNo = () => {
    try {
      setTitle("List of Payment");
      setApproved("3");
      setDataList(listoforderpayment);
      setDataAll(listoforderpayment);
    } catch (error) {
      console.log(error);
    }
  };

  const handleLoadApprovedNOBillingNo = () => {
    try {
      setApproved("1");
      setDataList(listofForPaymentApproved);
      setDataAll(listofForPaymentApproved);
    } catch (error) {
      console.log(error);
    }
  };

  const handleLoadNotApproved = () => {
    try {
      setApproved("0");
      setTitle("List of Approval");
      setDataList(listoforderpaymentNot);
      setDataAll(listoforderpaymentNot);
      setForFilterSearch(listoforderpaymentNot);
    } catch (error) {
      console.log(error);
    }
  };

  const handleLoadPaid = () => {
    try {
      setTitle("List of Paid");
      fetchListofPaid();
      setApproved("2");
      setDataList(numberOfPaid);
      setForFilterSearch(numberOfPaid);
      setlistoforderpaid(numberOfPaid);
      setDataAll(numberOfPaid);
    } catch (error) {
      console.log(error);
    }
  };

  async function handleShowModal(e, data) {
    e.preventDefault();
    try {
      setIsModalVisible(true);
      setOrderpaymentid(data.id);
      setSignature(data.status);
      setCheckedArray(JSON.parse(data.Payitem));
      setAttachmentId(JSON.parse(data.locations));
      setOpData(data);
    } catch (error) {
      console.log(error);
    }
  }

  const formatAMPM = (date) => {
    let d = new Date(date);
    let hours = d.getHours();
    let minutes = d.getMinutes();
    let ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? "0" + minutes : minutes;
    let strTime = hours + ":" + minutes + " " + ampm;
    return strTime;
  };

  function numberWithCommas(x) {
    return x?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  const finalSentence = (mySentence) => {
    return mySentence?.replace(/(^\w{1})|(\s+\w{1})/g, (letter) =>
      letter?.toUpperCase()
    );
  };

  const handleApproved = () => {
    
    setdisabledApproved(true)

    let accoundCode = Zaupayitem;
    
    let data = {};
    let accountname = [];
    let taxpayer_name = [];
    let address_of = [];
    let gender_text = [];
    let gender_value = [];
    let remarks = [];
    let requested_by = [];
    let account_code = [];
    let total_rate = [];
    let quantity = [];

    Swal.fire({
      title: `Are you sure you want to approve it?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Approve it!",
    }).then((result) => {
      if (result.isConfirmed) {
        API.graphql(
          graphqlOperation(getCreateOrderOfBilling, {
            id: orderpaymentid,
          })
        ).then(async (res) => {

            if (res?.data?.getCreateOrderOfBilling?.typeofapplication === "COE") {

              for (
                let i = 0;
                i < JSON.parse(res?.data?.getCreateOrderOfBilling?.Payitem).length;
                i++
              ){

                if(JSON.parse(res?.data?.getCreateOrderOfBilling.Payitem)[i]
                      .paymentitem === "") {
                          continue;
                }

                try {

                  taxpayer_name.push(
                    res.data.getCreateOrderOfBilling.owner
                      .replace(/'|Ñ|ñ/g, "N")
                      .replace(/[^a-zA-Z0-9 ]/g, "")
                      .toUpperCase()
                  );

                  address_of.push(res?.data?.getCreateOrderOfBilling?.address.replace(/'|Ñ|ñ/g, "N")
                  .replace(/[^a-zA-Z0-9 ]/g, "")
                  .toUpperCase() + "Quezon City");

                  accountname.push(
                    JSON.parse(res.data.getCreateOrderOfBilling.Payitem)[i]
                      .paymentitem
                  );

                  account_code.push(
                    accoundCode[
                      JSON.parse(res.data.getCreateOrderOfBilling.Payitem)[i]
                        .paymentitem
                    ]["AccountCode"]
                  );

                  total_rate.push(
                    Number(
                      JSON.parse(res.data.getCreateOrderOfBilling.Payitem)[i].total
                    )
                  );

                  quantity.push(
                    JSON.parse(res.data.getCreateOrderOfBilling.Payitem)[i]
                      .paymentitem && 1
                  );

                  gender_text.push("male");

                  gender_value.push("1");

                  remarks.push("Payment");

                  requested_by.push("Zoning Administration Unit");
                  
                } catch (error) {

                  Swal.fire(
                      "Error!",
                      `Failed to Generate Billing No`,
                      "error"
                    ).then(() => {
                      window.location.reload();
                      setIsModalVisible(false);
                      fetchListofOrderofPaymentsNot();
                      fetchListofOrderofPayments();
                    });

                  return;
                  
                }
              }

            } else { //

              for (
                let i = 0;
                i < JSON.parse(res?.data?.getCreateOrderOfBilling?.Payitem).length;
                i++
              ) {

              
                      if(JSON.parse(res?.data?.getCreateOrderOfBilling.Payitem)[i]
                      .paymentitem === "") {
                          continue;
                      }
                      
                      
                      try {

                        taxpayer_name.push(
                          res.data.getCreateOrderOfBilling.owner
                            .replace(/'|Ñ|ñ/g, "N")
                            .replace(/[^a-zA-Z0-9 ]/g, "")
                            .toUpperCase()
                        );
    
                        address_of.push(res.data.getCreateOrderOfBilling.lot_no
                          .replace(/'|Ñ|ñ/g, "N")
                          .replace(/[^a-zA-Z0-9 ]/g, "")
                          .toUpperCase() +" "+ res.data.getCreateOrderOfBilling.blk_no.replace(/'|Ñ|ñ/g, "N")
                          .replace(/[^a-zA-Z0-9 ]/g, "" ) +" "+ res.data.getCreateOrderOfBilling.location_street.replace(/'|Ñ|ñ/g, "N")
                          .replace(/[^a-zA-Z0-9 ]/g, "")
                          .toUpperCase() +" "+ res.data.getCreateOrderOfBilling.location_barangay.replace(/'|Ñ|ñ/g, "N")
                          .replace(/[^a-zA-Z0-9 ]/g, "")
                          .toUpperCase() +" "+ res.data.getCreateOrderOfBilling.location_district.replace(/'|Ñ|ñ/g, "N")
                          .replace(/[^a-zA-Z0-9 ]/g, "")
                          .toUpperCase() +" "+ "Quezon City");
    
                        accountname.push(
                          JSON.parse(res.data.getCreateOrderOfBilling.Payitem)[i]
                            .paymentitem
                        );
    
                        account_code.push(
                          accoundCode[
                            JSON.parse(res.data.getCreateOrderOfBilling.Payitem)[i]
                              .paymentitem
                          ]["AccountCode"]
                        );
    
                        total_rate.push(
                          Number(
                            JSON.parse(res.data.getCreateOrderOfBilling.Payitem)[i].total
                          )
                        );
    
                        quantity.push(
                          JSON.parse(res.data.getCreateOrderOfBilling.Payitem)[i]
                            .paymentitem && 1
                        );
    
                        gender_text.push("male");
    
                        gender_value.push("1");
    
                        remarks.push("Payment");
    
                        requested_by.push("Zoning Administration Unit");
                        
                      } catch (error) {


                        Swal.fire(
                            "Error!",
                            `Failed to Generate Billing No`,
                            "error"
                          ).then(() => {
                            window.location.reload();
                            setIsModalVisible(false);
                            fetchListofOrderofPaymentsNot();
                            fetchListofOrderofPayments();
                          });

                        return;
                        
                      }

              }
            
            
            }

         
            const toReturn_taxpayer_name = JSON.stringify(
              taxpayer_name.join("|||")
            ).replace(/"/g, "");
            const toReturn_address_of = JSON.stringify(
              address_of.join("|||")
            ).replace(/"/g, "");
            const toReturn_gender_text = JSON.stringify(
              gender_text.join("|||")
            ).replace(/"/g, "");
            const toReturn_gender_value = JSON.stringify(
              gender_value.join("|||")
            ).replace(/"/g, "");
            const toReturn_remarks = JSON.stringify(
              remarks.join("|||")
            ).replace(/"/g, "");
            const toReturn_requested_by = JSON.stringify(
              requested_by.join("|||")
            ).replace(/"/g, "");
            const toReturn_account_name = JSON.stringify(
              accountname.join("|||")
            ).replace(/"/g, "");
            const toReturn_account_code = JSON.stringify(
              account_code.join("|||")
            ).replace(/"/g, "");
            const toReturn_total_amount = JSON.stringify(
              total_rate.join("|||")
            ).replace(/"/g, "");
            const toReturn_quantity = JSON.stringify(
              quantity.join("|||")
            ).replace(/"/g, "");
  
            data = {
              officename: "City Planning and Development Office",
              officecode: "CPDO",
              taxpayer_name: toReturn_taxpayer_name,
              address: toReturn_address_of,
              gender_text: toReturn_gender_text,
              gender_value: toReturn_gender_value,
              remarks: toReturn_remarks,
              requestedby: toReturn_requested_by,
              accountname: toReturn_account_name,
              accountcode: toReturn_account_code,
              rate: toReturn_total_amount,
              quantity: toReturn_quantity,
            };

         
            /* Function to generate Billing number */

                // Display a loading indicator with Swal
            const loadingSwal = Swal.fire({
                icon: 'info',
                title: 'Processing for Approval',
                text: 'Please wait...',
                showConfirmButton: false, // Hide the "OK" button
                allowOutsideClick: false, // Prevent user interaction with the background
            });

            try {
              const postDataToGenerateOp = await GenerateOp.generate_billing_no_for_zau(data);
              
              const opNo = await postDataToGenerateOp;

              if(!opNo) {
                Swal.fire(
                  "Error!",
                  `Failed to Generate Billing No`,
                  "error"
                ).then(() => {
                  window.location.reload();
                  setIsModalVisible(false);
                  fetchListofOrderofPaymentsNot();
                  fetchListofOrderofPayments();
                  setdisabledApproved(false)
                });
              }

              const {bill_number, status_code } = opNo.data;

              await new Promise(resolve => setTimeout(resolve, 2000));

                if (status_code === "GC0") {
                  loadingSwal.close();
                  API.graphql(
                    graphqlOperation(updateCreateOrderOfBilling, {
                      input: {
                        id: res.data.getCreateOrderOfBilling.id,
                        order_payment_no: bill_number, //opData.id
                        Signature2: "1",
                        status:"4",
                        nameofapprover5: user.fname + " " + user.mname + " " + user.lname,
                        signatureDate2: new Date(),
                      },
                    })
                  ).then((response) => {
                    Swal.fire(
                      "Success!",
                      `Billing Number ${response.data.updateCreateOrderOfBilling.order_payment_no} is successufully generated`,
                      "success"
                    ).then(() => {
                      window.location.reload();
                      setIsModalVisible(false);
                      fetchListofOrderofPaymentsNot();
                      fetchListofOrderofPayments();
                      setdisabledApproved(false)
                    });
                  });
                } else {
                  API.graphql(
                    graphqlOperation(updateCreateOrderOfBilling, {
                      input: {
                        id: res.data.getCreateOrderOfBilling.id,
                        order_payment_no: "0", //opData.id
                        Signature2: "0",
                        status:"50",
                        signatureDate2: new Date(),

                      },
                    })
                  ).then(() => {
                    Swal.fire(
                      "Error!",
                      `Failed to Generate Billing No`,
                      "error"
                    ).then(() => {
                      window.location.reload();
                      setIsModalVisible(false);
                      fetchListofOrderofPaymentsNot();
                      fetchListofOrderofPayments();
                      setdisabledApproved(false)
                    });
                  });
                }
              
            } catch (error) {
              API.graphql(
                graphqlOperation(updateCreateOrderOfBilling, {
                  input: {
                    id: res.data.getCreateOrderOfBilling.id,
                    order_payment_no: "0", //opData.id
                    Signature2: "0",
                    status:"50",
                    signatureDate2: new Date(),

                  },
                })
              ).then(() => {
                Swal.fire(
                  "Error!",
                  `Failed to Generate Billing No`,
                  "error"
                ).then(() => {
                  window.location.reload();
                  setIsModalVisible(false);
                  fetchListofOrderofPaymentsNot();
                  fetchListofOrderofPayments();
                  setdisabledApproved(false)
                });
              });
            }   
        });
      }
    });
  };

  const handleApprovedForRelease = () => {
    try{
      Swal.fire({
        title: `Are you sure you want to approve it?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, Approve it!",
      }).then((result) => {
        if (result.isConfirmed) {
          API.graphql(
            graphqlOperation(getCreateOrderOfBilling, {
              id: orderpaymentid,
            })
          ).then((res) => {
            if(res?.data?.getCreateOrderOfBilling?.id) {
              API.graphql(
                graphqlOperation(updateCreateOrderOfBilling, {
                  input: {
                    id: res?.data?.getCreateOrderOfBilling?.id,
                    Signature2: "1",
                    status:"6",
                    nameofapprover5: user.fname + " " + user.mname + " " + user.lname,
                    signatureDate2: new Date(),
                  },
                })
              ).then(result => {
                 if(result) {
                    Swal.fire(
                      'Success',
                      'Successfully Approved',
                      'Success'
                    ).then(() => {
                      window.location.reload();
                    })
                 } else {
                  Swal.fire(
                    'Error',
                    'Failed to Approved',
                    'error'
                  ).then(() => {
                    window.location.reload();
                  })
                 }
              })
            } else {
              Swal.fire(
                'Error',
                'Failed to Approved',
                'error'
              ).then(() => {
                window.location.reload();
              });
            }
  
          })
        }
      })
    }catch(error){
      Swal.fire(
        'Error',
        'Failed to Approved',
        'error'
      ).then(() => {
        window.location.reload();
      })
    }
  
}

  const SearchValue = (event) => {
    const query = event;
    var updatedList = [...dataList];
    updatedList = updatedList.filter((item) => {
      return item.owner.toLowerCase().indexOf(query.toLowerCase()) !== -1;
    });
    setDataAll(updatedList);
  };

  async function handleRegenerateApplications(e, data) {
    e.preventDefault();
    try {
      Swal.fire({
        title:
        "Do you want to deny the application? May we ask for some details on why you want to deny it?",
        html: `<textarea id="remarks" rows="10" cols="50">`,
        inputAttributes: {
          autocapitalize: "off",
        },
        showCancelButton: true,
        confirmButtonText: "Deny",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          const remarks = Swal.getPopup().querySelector("#remarks").value;
          let a = {
            remarks: remarks,
            date: new Date(),
            deniedBy: user.fname + " " + user.mname + " " + user.lname,
          };
          return await API.graphql(
            graphqlOperation(getCreateOrderOfBilling, {
              id: data.id,
            })
          ).then(async (response) => {
            const jsonResRemarks = JSON.parse(
              response.data.getCreateOrderOfBilling.deniedRemarks
            );
            jsonResRemarks.push(a);
            return await API.graphql(
              graphqlOperation(updateCreateOrderOfBilling, {
                input: {
                  id: response.data.getCreateOrderOfBilling.id,
                  isDeny: "2",
                  status:"15",
                  deniedRemarks: JSON.stringify(jsonResRemarks),
                },
              })
            );
          });
        },
        allowOutsideClick: () => !Swal.isLoading(),
      }).then((result) => {
        if (result.isConfirmed) {
          notification["success"]({
            message: "success",
            description: "Successfully Approved",
          });
          setIsModalVisible(false);
          fetchListofOrderofPaymentsNot();
          window.location.reload();
        }
      });
    } catch (error) {
      console.log(error);
    }
  }

  async function handleShowRemarks(e, data) {
    e.preventDefault();
    try {
      setShowmodalRemarks(true);
      setRemarksArray(JSON.parse(data.deniedRemarks));
    } catch (error) {
      console.log("remarks array", error);
    }
  }

  async function handleCloseshowRemarks() {
    setCheckedArray([]);
    setShowmodalRemarks(false);
    setOrderpaymentid("");
    setSignature("");
    setCheckedArray([]);
    setAttachmentId([]);
    setOpData([]);
  }

  const handleResetSearch = (e) => {
    e.preventDefault();
    setToSearch("");
    setDataAll([]);
  };

  const handleCloseData = () => {
    try {
      setIsModalVisible(false);
      setOrderpaymentid("");
      setSignature("");
      setCheckedArray([]);
      setAttachmentId([]);
      setOpData([]);
    } catch (error) {
      console.log(error);
    }

  }

  const month = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const columns = [
    {
      title: "Name of Applicant",
      dataIndex: "owner",
      key: "owner",
      width: 250,
      render: (text, record) => (
        <span style={{ fontSize: "16px", fontWeight: "normal" }}>
          {record.owner}
        </span>
      ),
    },
    {
      title: "Project Activity",
      dataIndex: "project_activity",
      key: "project_activity",
      width: 310,
      render: (text, record) => (
        <span style={{ fontSize: "16px", fontWeight: "normal" }}>
          {record.project_activity}
        </span>
      ),
    },
    {
      title: "Date created",
      dataIndex: "date",
      key: "locale",
      width: 150,
      render: (text, record) => (
        <Tag color="cyan" style={{ fontSize: "16px", fontWeight: "normal" }}>
          {month[new Date(record.createdAt).getMonth()]}{" "}
          {new Date(record.createdAt).getDate()}{" "}
          {new Date(record.createdAt).getFullYear()}{" "}
          {formatAMPM(record.createdAt)}
        </Tag>
      ),
    },
    {
      title: "Grand Total",
      dataIndex: "grandTotal",
      key: "grandTotal",
      width: 100,
      render: (text, record) => (
        <Tag color="volcano" style={{ fontSize: "16px", fontWeight: "normal" }}>
        {record.grandTotal ? (`PHP ${numberWithCommas(record.grandTotal)}`): ""}
      </Tag>
      ),
    },

    {
      title: "Billing Officer",
      dataIndex: "grand_total_payment_no",
      key: "grand_total_payment_no",
      width: 150,
      render: (text, record) => (
        <Tag color="volcano" style={{ fontSize: "16px", fontWeight: "normal" }}>
          {record.billing_officer !== null
            ? finalSentence(record.billing_officer)
            : ""}
        </Tag>
      ),
    },
    {
      title: "Type of Application",
      width: 120,
      align: "center",
      render: (text, record) => (
        <span style={{ fontSize: "16px", fontWeight: "normal" }}>
          {
            record.isGovementInstitution ? (
              <Tag color="volcano">Goverment</Tag>
            ) :  record.isNoPaymenItem ? (
              <Tag color="cyan">Amendment</Tag>
            ) : record.doesHaveOldOP ? (
              <Tag color="magenta">(With old order of payment)</Tag>
            ) : null
          }
        </span>
      ),
    },
    {
      title: "Status",
      width: 200,
      align: "center",
      render: (text, record) => (
        <span style={{ fontSize: "16px", fontWeight: "normal" }}>
          {/* {record.isDeny === "1" && record.opStatus === "0" ? (
            <Button>
              <Tag color="#f50">Denied</Tag>
            </Button>
          ) : record.opStatus === "1" &&
            record.Signature1 === "0" &&
            record.Signature2 === "0" ? (
            <Button>
              <Tag color="#87d068">For Approval</Tag>
            </Button>
          ) : record.opStatus === "1" &&
            record.Signature1 === "1" &&
            record.Signature2 === "0" &&
            record.order_payment_no === "0" ? (
            <Button>
              <Tag color="#87d068">For Approval</Tag>
            </Button>
          ) : record.opStatus === "1" &&
            record.Signature1 === "1" &&
            record.Signature2 === "1" &&
            record.order_payment_no !== "0" &&
            record.OrNumber === "0" ? (
            <Button>
              <Tag color="#108ee9">For Payment</Tag>
            </Button>
          ) : (
            <Tag color="#108ee9">For Paid</Tag>
          )} */}

          
          {
            record.status === "1" ? (
              <Tag color="#87d068">New Application</Tag>
            ) :  record.status === "2" ? (
              <Tag color="#87d068">For Recommendation</Tag>
            ) :  record.status === "3" ? (
              <Tag color="#87d068">For Approval</Tag>
            )  : record.status === "4" ? (
              <Tag color="#87d068">For Payment </Tag>
            ) : record.status === "5" ? (
              <Tag color="#87d068">Paid</Tag>
            ) : record.status === "15" ? (
              <Button>
                 <Tag color="#f50">Denied</Tag>
              </Button>
            ) : null
          }
        </span>
      ),
    },
    {
      title: "",
      key: "action",
      width: 80,
      render: (text, record) => (
        <>
          {" "}
          <span>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginRight: "10px",
              }}
            >
              <button
                type="primary"
                className="btn btn-warning btn-sm"
                onClick={(e) => handleShowModal(e, record)}
                style={{ marginRight: "10px" }}
              >
                <i className="fa fa-file-text"></i>&nbsp;&nbsp;<b>VIEW</b>
              </button>
              {record.status === "3" && (
                <button
                  type="primary"
                  className="btn btn-danger btn-sm"
                  onClick={(e) => handleRegenerateApplications(e, record)}
                >
                  <i className="fa fa-file-text"></i>&nbsp;&nbsp;<b>Deny</b>
                </button>
              )}
            </div>
          </span>
        </>
      ),
    },
  ];

  return (
    <div>
      <div class="form-row" style={{ marginBottom: "50px" }}>
        <div class="col-4">
          <div onClick={handleLoadNotApproved}>
            <Card hoverable style={{ width: '100%', borderRadius: '16px', boxShadow: '0 0 16px rgba(0, 0, 0, 0.1)' }}>
              <Statistic
                title="For Approval"
                value={listoforderpaymentNot.length}
                valueStyle={{
                  color: "#cf1322",
                }}
                prefix={<UserOutlined />}
              />
            </Card>
          </div>
        </div>
        <div class="col-4">
          <div onClick={handleLoadApprovedWithBillingNo}>
            <Card hoverable style={{ width: '100%', borderRadius: '16px', boxShadow: '0 0 16px rgba(0, 0, 0, 0.1)' }}>
              <Statistic
                title="For Payment"
                value={listoforderpayment.length}
                valueStyle={{
                  color: "#E7800F",
                }}
                prefix={<UserOutlined />}
                onClick={() => alert("x")}
              />
            </Card>
          </div>
        </div>

        <div class="col-4">
          <div onClick={handleLoadPaid}>
            <Card hoverable style={{ width: '100%', borderRadius: '16px', boxShadow: '0 0 16px rgba(0, 0, 0, 0.1)' }}>
              <Statistic
                title="List of Paid"
                value={numberOfPaid.length}
                valueStyle={{
                  color: "#E7800F",
                }}
                prefix={<UserOutlined />}
                onClick={() => alert("x")}
              />
            </Card>
          </div>
        </div>
      </div>

      <div className="d-flex justify-content-start">
        <div className="p-2 col-example text-left">
          <div className="p-2 col-example text-left">
            <h2>{title}</h2>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-md-4">
          <Input
            style={{ width: "100%", marginBottom: "20px", borderRadius: "16px" }}
            onChange={(e) => SearchValue(e.target.value)}
            placeholder="Search...."
          />
        </div>
        <div className="col-md-2">
          <button
            type="button"
            style={{ width: "30%", marginLeft: "10px" }}
            className="btn btn-warning btn-sm"
            onClick={(e) => handleResetSearch(e)}
          >
            <i className="fa fa-refresh" aria-hidden="true"></i>
          </button>
        </div>
      </div>
    

      <Table
        bordered
        loading={dataAll.length === 0 ? true : false}
        columns={columns}
        dataSource={dataAll}
        size="middle"
        pagination={{
          pageSize: 10, // display 5 items per page
          total: dataAll.length, // total number of items
        }}
        scroll={{ x: true }}
  
      />

      <Modal
        visible={isModalVisible}
        width={1200}
        closable={false}
        footer={[
          <>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Button onClick={handleCloseData} danger>
                Close
              </Button>

              {signature === "3" && !opData?.isGovementInstitution && !opData?.isNoPaymenItem && !opData?.doesHaveOldOP ? (
                <Button type="primary" onClick={(e) => handleApproved(e)} disabled={disabledApproved}>
                  Approve
                </Button>
              ) : null}

             {signature === "3" && opData?.isGovementInstitution && !opData?.isNoPaymenItem  && !opData?.doesHaveOldOP ? (
                <Button type="primary" onClick={(e) => handleApprovedForRelease(e)} >
                  Approve For Release
                </Button>
              ) : null}

             {signature === "3" && opData?.isNoPaymenItem && !opData?.isGovementInstitution && !opData?.doesHaveOldOP ? (
                <Button type="primary" onClick={(e) => handleApprovedForRelease(e)}>
                  Approve For Release
                </Button>
              ) : null}
              
              

             {signature === "3" && opData?.doesHaveOldOP && !opData?.isGovementInstitution && !opData?.isNoPaymenItem ? (
                <Button type="primary" onClick={(e) => handleApprovedForRelease(e)}>
                 Approve For Release
                </Button>
              ) : null}

              
             {signature === "3" && opData?.doesHaveOldOP && !opData?.isGovementInstitution && opData?.isNoPaymenItem ? (
                <Button type="primary" onClick={(e) => handleApprovedForRelease(e)}>
                 Approve For Release
                </Button>
              ) : null}
              
              

            </div>
          </>,
        ]}
      >
          <Row>
            <Col xs={24} xl={24}>
              <Card
               title={
                (!opData?.isGovementInstitution) && (!opData?.isNoPaymenItem)  && (!opData?.doesHaveOldOP) ? (
                  <Alert
                  style={{ fontWeight: "bold", fontSize: "16px" }}
                  message={`Billing Number: ${
                    opData.order_payment_no !== "0"
                      ? opData.order_payment_no
                      : "Not Yet Approved"
                  }`}
                  type="info"
                />
                ):null
               
              }
              >
               {opData?.isGovementInstitution &&  
                <Card>
                  This application is for goverment Institution
                </Card>
                }

                {opData?.isNoPaymenItem &&  
                <Card>
                  This application is for Ammendment
                </Card>
                }
                
                <br></br>
                <Collapse size="large" defaultActiveKey={['1', '2']}>
                  {opData?.typeofapplication === "COE" ? (
                    <>
                       <Panel header={`Locational Details - CE No. ${opData?.ceNo}`} key="1">
                    <Descriptions layout="vertical" size="middle" bordered>
                      <Descriptions.Item label="Name of Applicant">
                        <b>
                          {opData && String(opData.owner).toLocaleUpperCase()}
                        </b>
                      </Descriptions.Item>
                      <Descriptions.Item label="Project Activity">
                        <b>
                          {opData &&
                            String(opData.project_activity).toUpperCase()}
                        </b>
                      </Descriptions.Item>
                      <Descriptions.Item label="Project Location">
                        <b>{
                              opData?.address ? (
                                opData?.address
                              ) : (
                                 opData && `${opData.lot_no}, ${opData.blk_no}, ${opData.location_street}, ${opData.location_barangay}, ${opData.location_district}, QUEZON CITY`
                              )
                           }
                        </b>
                      </Descriptions.Item>
                      <Descriptions.Item label="Floor Area (sq.m)">
                        <b>
                          {opData && String(opData.floor_area).toUpperCase()}
                        </b>
                      </Descriptions.Item>
                      <Descriptions.Item label="Lot Area (sq.m)">
                        <b>{opData && String(opData.lot_area).toUpperCase()}</b>
                      </Descriptions.Item>
                      <Descriptions.Item label="Application No">
                        <b>
                          {opData &&
                            String(opData.application_no).toUpperCase()}
                        </b>
                      </Descriptions.Item>
                      <Descriptions.Item label="Postal Address">
                        <b>
                          {String(opData.postalAddress)}
                        </b>
                      </Descriptions.Item>
                      <Descriptions.Item label="Prescriptive Notation:">
                          <b>
                            {opData &&
                              String(
                                opData.evaluation_facts_extended
                              ).toUpperCase()}
                          </b>
                        </Descriptions.Item>
                    </Descriptions>
                  </Panel>
                 
                  { (!opData?.isGovementInstitution) && (!opData?.isNoPaymenItem)  && (!opData?.doesHaveOldOP) &&
                      <Panel header="Order of Payment Details" key="2">
                            <Card type="inner" style={{ marginTop: "10px" }}>
                              <Row gutter={[8, 16]}>
                                <table className="table-responsive">
                                  <table className="table table-bordered">
                                    <thead>
                                      <tr>
                                        <th scope="col">Payitem</th>
                                        <th scope="col">FEES</th>
                                        <th scope="col">TOTAL</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {checkArray?.map((x, i) => (
                                        <tr>
                                          <td>{checkArray[i]["paymentitem"]}</td>
                                          <td>{checkArray[i]["fees"]}</td>
                                          <td>{checkArray[i]["total"]}</td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                </table>
                              </Row>
                            </Card>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "end",
                                marginTop: "30px",
                              }}
                            >
                              <Row gutter={[8, 24]}>
                                <Col span={24}>
                                  <span>
                                    <label className="loginInput-label" htmlFor="fname">
                                      GRAND TOTAL:
                                    </label>
                                    <Input
                                      style={{
                                        fontWeight: "bold",
                                        fontSize: "20px",
                                        width: "80%",
                                        display: "flex",
                                        justifyContent: "",
                                      }}
                                      value={`Php ${opData.grandTotal}`}
                                    />
                                  </span>
                                </Col>
                              </Row>
                            </div>
                        </Panel>
                      }
                    </>
                  ) : (
                    <>
                      <Panel header="Locational Details" key="1">
                        <Descriptions layout="vertical" size="middle" bordered>
                          <Descriptions.Item label="Name of Applicant">
                            <b>
                              {opData && String(opData.owner).toLocaleUpperCase()}
                            </b>
                          </Descriptions.Item>
                          <Descriptions.Item label="Project Activity">
                            <b>
                              {opData &&
                                String(opData.project_activity).toUpperCase()}
                            </b>
                          </Descriptions.Item>
                          <Descriptions.Item label="Project Location">
                            <b>{opData && `${opData.lot_no}, ${opData.blk_no}, ${opData.location_street}, ${opData.location_barangay}, ${opData.location_district}, QUEZON CITY`}</b>
                          </Descriptions.Item>
                          <Descriptions.Item label="Floor Area (sq.m)">
                            <b>
                              {opData && String(opData.floor_area).toUpperCase()}
                            </b>
                          </Descriptions.Item>
                          <Descriptions.Item label="Lot Area (sq.m)">
                            <b>{opData && String(opData.lot_area).toUpperCase()}</b>
                          </Descriptions.Item>
                          <Descriptions.Item label="Application No">
                            <b>
                              {opData &&
                                String(opData.application_no).toUpperCase()}
                            </b>
                          </Descriptions.Item>
                          <Descriptions.Item label="District">
                            <b>
                              {opData &&
                                String(opData.location_district).toUpperCase()}
                            </b>
                          </Descriptions.Item>
                          <Descriptions.Item label="Zone Classifications">
                            <b>
                              {opData &&
                                String(opData.zone_classification).toUpperCase()}
                            </b>
                          </Descriptions.Item>
                          <Descriptions.Item label="Evaluation of Facts:">
                            <b>
                              {opData &&
                                String(opData.evaluation_facts).toUpperCase()}
                            </b>
                          </Descriptions.Item>
                           <Descriptions.Item label="Prescriptive Notation:">
                            <b>
                              {opData &&
                                String(opData.evaluation_facts_extended).toUpperCase()}
                            </b>
                          </Descriptions.Item>
                        </Descriptions>
                      </Panel>

                      { (!opData?.isGovementInstitution) && (!opData?.isNoPaymenItem)  && (!opData?.doesHaveOldOP) &&
                            <Panel header="Order of Payment Details" key="2">
                            <Card type="inner" style={{ marginTop: "10px" }}>
                              <Row gutter={[8, 16]}>
                                <table className="table-responsive">
                                  <table className="table table-bordered">
                                    <thead>
                                      <tr>
                                        <th scope="col">Payitem</th>
                                        <th scope="col">FEES</th>
                                        <th scope="col">TOTAL</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {checkArray?.map((x, i) => (
                                        <tr>
                                          <td>{checkArray[i]["paymentitem"]}</td>
                                          <td>{checkArray[i]["fees"]}</td>
                                          <td>{checkArray[i]["total"]}</td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                </table>
                              </Row>
                            </Card>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "end",
                                marginTop: "30px",
                              }}
                            >
                              <Row gutter={[8, 24]}>
                                <Col span={24}>
                                  <span>
                                    <label className="loginInput-label" htmlFor="fname">
                                      GRAND TOTAL:
                                    </label>
                                    <Input
                                      style={{
                                        fontWeight: "bold",
                                        fontSize: "20px",
                                        width: "80%",
                                        display: "flex",
                                        justifyContent: "",
                                      }}
                                      value={`Php ${opData.grandTotal}`}
                                    />
                                  </span>
                                </Col>
                              </Row>
                            </div>
                          </Panel>
                        }
                          <Panel header="Attachment" key="3">
                            {" "}
                            <Card type="inner" style={{ marginTop: "10px" }}>
                              <Row gutter={[8, 16]}>
                                <table className="table-responsive">
                                  <table className="table table-bordered">
                                    <thead>
                                      <tr>
                                        <th scope="col">Files</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {attachmentId?.map((x, i) => (
                                        <tr key={i}>
                                          <td>
                                            <Image width={100} height={100} src={x} />
                                          </td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                </table>
                              </Row>
                            </Card>
                          </Panel> 
                         </>
                      )}
                </Collapse>
              </Card>
            </Col>
          </Row>
      </Modal>
      <Modal
        title="Things to do"
        centered
        width={1000}
        visible={showmodalRemarks}
        closable={false}
        footer={[
          <>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Button onClick={handleCloseshowRemarks} danger>
                Close
              </Button>
            </div>
          </>,
        ]}
      >
        <table class="table table-bordered">
          <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">Remarks</th>
              <th scope="col">Date</th>
            </tr>
          </thead>
          <tbody>
            {remarksArray?.map((item, i) => (
              <tr key={i}>
                <th scope="row">{i + 1}</th>
                <td>{item.remarks.toLocaleUpperCase()}</td>
                <td>
                  {new Date(item.date).toLocaleDateString("en-US") +
                    " " +
                    new Date(item.date).toLocaleTimeString("en-US")}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </Modal>
    </div>
  );
};

export default Approver5;
